<template>
  <div class="flex-container">
    <div class="menubar flex-100">
      <span class="title" v-if="modelValue.rekeningData.step===0">
        Welke rol heeft u binnen deze rekening?
      </span>
      <span class="title" v-else>Welke rol heeft deze persoon?</span>
      <button
        v-if="
          modelValue.goalData.box != '1'
          && !$parent.port
          && modelValue.goalData.type != 'studiekinderen'
        "
        @click="$parent.resetType()" style="float:right;"
      >
        <awesomeIcon icon="edit"/>
        <span class="hide-mobile"> Rekening wijzigen</span>
      </button>
    </div>
    <div v-if="sdk.isBecome" class="msg flex-100">
      <b>Let op!</b>
      Als adviseur bent u ingelogd als {{$parent.email}},
      u moet de vragen beantwoorden alsof u deze persoon bent.
    </div>
    <template v-if="modelValue.rekeningData.type !='Bedrijfsrekening'">

      <div
        v-if="modelValue.rekeningData.type=='Particuliere rekening'"
        class="card option most-used-selected flex-33"
      >
        <div
          v-if="
            modelValue.goalData.box != '1'
            || !findKey(modelValue.persoonsData, { 'type': 'Rekeninghouder' })
          "
          @click="
            modelValue.persoonsData[modelValue.rekeningData.step].type='Rekeninghouder';
            $parent.storeIntake(2, modelValue.rekeningData.step);
          "
        >
          <div class="most-used-content">
            <b>Meest gekozen</b>
          </div>
          <h2><awesomeIcon icon="user"/> Rekeninghouder</h2>
          <p v-if="modelValue.rekeningData.step===0">
            U bent zelf eigenaar van de rekening.
          </p>
          <p v-else>
            Is de persoon die u wilt toevoegen mede-rekening houder?
          </p>
        </div>
        <div v-else class="no-border">
          <h2><awesomeIcon icon="user"/> Rekeninghouder</h2>
          <p v-if="modelValue.rekeningData.step===0">
            U bent zelf eigenaar van de rekening.
          </p>
          <p v-else>
            Is de persoon die u wilt toevoegen mede-rekening houder?
          </p>
          <p class="red">
            <awesomeIcon icon="exclamation-circle"/>
            U kunt deze optie niet kiezen, de rekening mag maar 1 rekeninghouder bevatten.
            Pas de rol van de andere rekeninghouder aan of verwijder deze persoon.
          </p>
        </div>
      </div>
      <div
        class="card option most-used-unselected flex-33"
        v-if="modelValue.persoonsData[modelValue.rekeningData.step].type!='Volmacht'"
        @click="addVolmacht"
      >
        <h2><awesomeIcon icon="eye"/> Gevolmachtigde</h2>
        <p v-if="modelValue.rekeningData.step===0">
          Bent u niet zelf de eigenaar? Registreer dan een volmacht.
        </p>
        <p v-else>
          Wilt u iemand toevoegen met toegang tot deze rekening?
          Registreer deze dan als gevolmachtigde.
        </p>
      </div>

    </template>
    <template v-if="modelValue.rekeningData.type == 'Bedrijfsrekening'">

      <div
        class="card option most-used-selected flex-33"
        v-if="modelValue.persoonsData[modelValue.rekeningData.step].type!='UBO/Bestuurder'"
        @click="
          modelValue.persoonsData[modelValue.rekeningData.step].type='UBO/Bestuurder';
          $parent.storeIntake(2, modelValue.rekeningData.step);
        "
      >
        <div class="most-used-content">
          <b>Meest gekozen</b>
        </div>
        <h2><awesomeIcon icon="briefcase"/> Bestuurder &amp; UBO</h2>
        <p v-if="modelValue.rekeningData.step===0">
          U vervult beiden rollen.
        </p>
        <p v-else>
          Vervult de persoon die u wilt toevoegen beiden rollen?
        </p>
      </div>

      <div
        class="card option most-used-unselected flex-33"
        v-if="modelValue.persoonsData[modelValue.rekeningData.step].type!='Bestuurder'"
        @click="
          modelValue.persoonsData[modelValue.rekeningData.step].type='Bestuurder';
          $parent.storeIntake(2, modelValue.rekeningData.step);
        "
      >
        <h2><awesomeIcon icon="user-tie"/> Bestuurder</h2>
        <p v-if="modelValue.rekeningData.step===0">
          U bent alleen bestuurder.
        </p>
        <p v-else>
          Is de persoon die u wilt toevoegen een bestuurder?
        </p>
      </div>

      <div
        class="card option most-used-unselected flex-33"
        v-if="modelValue.persoonsData[modelValue.rekeningData.step].type!='UBO'"
        @click="
          modelValue.persoonsData[modelValue.rekeningData.step].type='UBO';
          $parent.storeIntake(2, modelValue.rekeningData.step);
        "
      >
        <h2><awesomeIcon icon="wallet"/> UBO</h2>
        <p v-if="modelValue.rekeningData.step===0">
          U bent alleen uiteindelijk belanghebbenden.
        </p>
        <p v-else>
          Is de persoon die u wilt toevoegen een uiteindelijk belanghebbenden?
        </p>
      </div>

      <div
        class="card option most-used-unselected flex-33"
        v-if="modelValue.persoonsData[modelValue.rekeningData.step].type!='Volmacht'"
        @click="addVolmacht"
      >
        <h2><awesomeIcon icon="eye"/> Volmacht</h2>
        <p v-if="modelValue.rekeningData.step===0">
          U bent geen eigenaar.
        </p>
        <p v-else>
          Wilt u iemand toegang geven tot de bedrijfsrekening?
        </p>
      </div>

    </template>
  </div>
</template>

<script>
import { findKey } from 'lodash-es';

export default {
  name: 'IntakePersonRoleSelectPage',
  emits: ['update:model-value'],
  props: {
    modelValue: Object,
  },
  computed: {
    value() {
      return this.modelValue;
    },
  },
  methods: {
    findKey,
    addRekeninghouder() {
      if (
        this.modelValue.persoonsData.length === 1
        && this.modelValue.persoonsData[0].type === 'Volmacht'
      ) {
        this.modelValue.persoonsData.push({ type: 'Rekeninghouder' });
      }
    },
    addVolmacht() {
      if (this.modelValue.rekeningData.type === 'Particuliere rekening') {
        this.$store.state.confirm.toggle({
          text: 'De rol volmacht is geen eigenaar van de rekening, weet u zeker dat u deze rol wilt selecteren?',
          cb: (confirmed) => {
            if (confirmed) {
              this.modelValue.persoonsData[this.modelValue.rekeningData.step].type = 'Volmacht';
              this.addRekeninghouder();
              this.$parent.storeIntake(2, this.modelValue.rekeningData.step);
            }
          },
        });
      } else {
        this.modelValue.persoonsData[this.modelValue.rekeningData.step].type = 'Volmacht';
        this.$parent.storeIntake(2, this.modelValue.rekeningData.step);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  .flex-container {
    column-gap: 20px;
    row-gap: 20px;
    @media #{$mobile} {
      row-gap: 10px;
      padding: 43px 10px 10px;
    }
  }
</style>
